/* eslint-disable no-use-before-define */
import React from 'react'
import { arrayFrom, hideModal } from '../twd/twd'

export default ({
    title='Important Disclosures',
    html='-',
    modalClass='modal-dialog modal-md',
    buttons,
    buttonClass = 'col-centered-8',
    buttonStyle = {display:'flex'},
    isTitleHTML = false,

} = {}) => {


    return <React.Fragment>
    <div className={modalClass}>
    <div className="modal-content">
        <div className="modal-header">
            <button
                className="close"
                aria-label="close"
                data-name="disclosures-close-link"
                type="button"
                onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            { isTitleHTML
                ? <h2 className="modal-title text-center vertical-offset-sm" dangerouslySetInnerHTML={{__html:title}} ></h2>
                : <h2 className="modal-title text-center vertical-offset-sm">{title}</h2>
            }
            <div className="row">
            <div className="col-xs-12 col-md-12" dangerouslySetInnerHTML={{__html:html}} />

            </div>
        </div>

        <div className="modal-footer">
        <div className="row">
        <div className={buttonClass} style={buttonStyle}>
            { buttons && arrayFrom(buttons).map( (b,i) => {
                return <button type="button" key={i}
                    style={b.style || {}}
                    className={b.className || 'btn btn-primary'}
                    onClick={b.onClick}>{b.label}</button>
            })}
            { !buttons && <button className="btn btn-block btn-primary" type="button"
                onClick={hideModal}
            >Close</button> }
        </div>
        </div>
        </div>
    </div>
    </div>

    </React.Fragment>
}
